module.exports = __webpack_public_path__ + "static/media/XVAniversario2.65af906f.jpg";